import { render, staticRenderFns } from "./RequestPayment.vue?vue&type=template&id=0435f5a6"
import script from "./RequestPayment.vue?vue&type=script&lang=js"
export * from "./RequestPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports